import { connect } from 'react-redux';
import { patientEngagementSortTable } from 'store/actionCreators/patientEngagement';
import { getSortOrder, getSortBy } from 'store/selectors/patientEngagement';

import PatientEngagementHeader from 'components/PatientEngagement/Header';

const mapStateToProps = state => ({
  sortOrder: getSortOrder(state),
  sortBy: getSortBy(state),
});

const mapDispatchToProps = {
  sortTable: patientEngagementSortTable,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientEngagementHeader);
